import React, { useEffect, useState } from "react";

function MobileStickyBar({ onHandleShowMap, showMap }) {
  return (
    <>
      <div className="mobile-handlers-wrap mobile_handlers-sticky">
        <div className="mobile-handlers-inner uk-animation-slide-bottom-small ">
          <ul className="uk-width-1-1 uk-subnav uk-subnav-pill mobile mobile-handlers">
            <li
              className={`uk-width-expand uk-padding-remove-left uk-flex uk-flex-center ${
                !showMap && "handler-active"
              }`}
            >
              <button
                type="button"
                className="uk-button uk-link-button"
                onClick={onHandleShowMap}
              >
                <i className="fas fa-list uk-margin-small-right"></i>Lista
              </button>
            </li>
            <li
              className={`uk-width-expand uk-padding-remove-left uk-flex uk-flex-center ${
                showMap && "handler-active"
              }`}
            >
              <button
                type="button"
                className="uk-button uk-link-button"
                onClick={onHandleShowMap}
              >
                <i className="fas fa-map-location-dot uk-margin-small-right"></i>
                Mappa
              </button>
            </li>
          </ul>
        </div>
      </div>
      <div id="safe-sticky" style={{ height: "50px" }}></div>
    </>
  );
}

export default MobileStickyBar;
